
import React from 'react';
import { PLANS } from './AMCConstants';
import ZProps from './zprops';
import ZUtil from './zutil';
import { ROUTER } from "./AMCRouter";
import AMC from "./AMC";
import PleaseStandBy from "./PleaseStandBy";
import AMCConstants from './AMCConstants';
import { AutomaticJoiningForm } from './AMCAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

var AMCBanners = {
	last: null,
	DELAY_BETWEEN_MANUALLY_CLOSED_BANNERS: 24*60*60*1000,
	onClose: function() {
		ZUtil.setCandy("banner.closed_at", "" + Date.now());
		let e = document.getElementById("zbanner");
		if (e) {
			e.style.display = "none";
		}
		this.container.forceUpdate();
	},
	getBanner(container) {
		this.container = container;
		let closed_at = parseInt(ZUtil.getCandy("banner.closed_at") || "0", 10);
		if (Date.now() - closed_at < this.DELAY_BETWEEN_MANUALLY_CLOSED_BANNERS) {
			this.last = { banner: null, bannerbottom: 0 };
		}
		if (ZProps.get("beta") || ZProps.get("ninja") || ZProps.get("path").endsWith("/beta") || ZProps.get("path") === "/") {
			this.last = { banner: null, bannerbottom: 0 };
		}
		if (!this.last) {
			let user = ZProps.get("user");
			let GUEST_BANNERS = [ <AMCBannerFOMO user={user} onClose={this.onClose.bind(this)} />, <AMCBannerBrains onClose={this.onClose.bind(this)} />, <AMCBannerJarvis user={user} onClose={this.onClose.bind(this)} />  ];
			let MEMBER_BANNERS = [ <AMCBannerFOMO user={user} onClose={this.onClose.bind(this)} />, <AMCBannerJarvis user={user} onClose={this.onClose.bind(this)} /> ];
			switch (user.plan) {
				case "guest" :
					this.last = { banner: ZUtil.randomElement(GUEST_BANNERS), bannerbottom: "19em" };
					break;
				case "member" :
					this.last = { banner: ZUtil.randomElement(MEMBER_BANNERS), bannerbottom: "19em" };
					break;
				default :
					this.last = { banner: null, bannerbottom: 0 };
					break;
			}
		}
		return this.last;
	}
}
	
export default AMCBanners;

class AMCBannerFOMO extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { user, onClose } = this.props;
		return (
		<div className="AMCBanner" id="zbanner">
			{ onClose ? <div className="AMCBannerCloseButton" onClick={onClose}><FontAwesomeIcon icon={faTimes} /></div> : '' }
			<div className="BannerFOMOThumb">
				<img alt="" src="/images/banners/banner1.png" />
			</div>
			<div className="AMCBannerRightSide50">
				<AMCBannerPricingTable user={user} />
				<div className="BannerFOMOCallToAction">
				</div>
			</div>
			<h1 className="BannerFOMOCallToAction">It's <strong>freaking awesome</strong>, it's <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/search?q=machine+learning">happening now</a>, and it's not too late to <strong><a href="/-/pricing">join the party!</a></strong></h1>
		</div>
		);
	}
}

class AMCBannerBrains extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { onClose } = this.props;
		return (
			<div className="AMCBanner" id="zbanner">
				{ onClose ? <div className="AMCBannerCloseButton" onClick={onClose}><FontAwesomeIcon icon={faTimes} /></div> : '' }
				<div className="AMCBannerLeftPanel">
					<img alt="" src="/images/banners/banner2L.png" />
					<h1>Software is <a target="_blank" rel="noopener noreferrer" href="https://a16z.com/2011/08/20/why-software-is-eating-the-world/">eating the world</a>.</h1>
				</div>
				<div className="AMCBannerMiddlePanel">
					<img alt="" src="/images/banners/banner2M.png" />
					<h1>Now it's also <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/search?q=artificial+intelligence">eating brains</a>.</h1>
				</div>
				<div className="AMCBannerRightPanel">
					<AutomaticJoiningForm submit_button_label="Yum!" />
				</div>
			</div>
		);
	}
}

class AMCBannerJarvis extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { onClose, user } = this.props;
		return (
			<div className="AMCBanner" id="zbanner">
				{ onClose ? <div className="AMCBannerCloseButton" onClick={onClose}><FontAwesomeIcon icon={faTimes} /></div> : '' }
				<div className="AMCBannerLeftPanel2">
					<img alt="" src="/images/banners/banner3L.png" />
					<p>Jarvis is going to be freaking awesome. We can all just wait decades for a FAANG to build it, and hope it won't have too many ads, or millions of <strong>ordinary grunts</strong> like us can get give it a try, creating larger and larger federations of increasingly intelligent and diverse services. We're thinkin' option B...</p>
				</div>
				<div className="AMCBannerRightSide50">
					<AMCBannerPricingTable user={user} />
				</div>
			</div>
		);
	}
}

class AMCBannerPricingTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		AMC.getPricingPlans((err, plans) => {
			if (!err) {
				this.setState({ plans: plans });
			} else {
				this.setState({ error: err });
			}
		});
	}
	render() {
		let { user } = this.props;
		let { plans } = this.state;
		if (!plans) {
			return <PleaseStandBy />;
		}
		plans = plans.subscriptions;
		return (
			<div className="AMCBannerPricingTable">
				<table><tbody>
					<tr>
						<th><FontAwesomeIcon icon={PLANS.guest.icon} /></th>
						<th><FontAwesomeIcon icon={PLANS.member.icon} /></th>
						{ plans.map( (p, index) => {
							return <th key={"th" + index}><FontAwesomeIcon icon={AMCConstants.PLAN_ICONS[p.monthly.level]} /></th>
						} )}
					</tr>
					<tr>
						<th><em>automatic.ai</em>Guest</th>
						<th><em>automatic.ai</em>Member</th>
						{ plans.map( (p, index) => {
							return <th key={"th2" + index}><em>automatic.ai</em>{p.monthly.level}</th>
						} )}
					</tr>
					<tr>
					<td><strong>free</strong></td>
					<td><strong>FREE</strong></td>
						{ plans.map( (p, index) => {
							let plan = p.monthly;
							return <td key={"td" + index}><strong>${ZUtil.toPrice(plan.pricing)}/mo</strong></td>
						} )}
					</tr>
					<tr>
						<td></td>
						<td>{user.plan === "guest" ? <button><a href={AMCConstants.PRICING_URI} onClick={ROUTER.pushRoute.bind(ROUTER, AMCConstants.PRICING_URI)}>join</a></button> : ""}</td>
						<td><button className="BannerFOMOSeePlansButton"><a href={AMCConstants.PRICING_URI} onClick={ROUTER.pushRoute.bind(ROUTER, AMCConstants.PRICING_URI)}>see plans</a></button></td>
						<td><button className="BannerFOMOSeePlansButton"><a href={AMCConstants.PRICING_URI} onClick={ROUTER.pushRoute.bind(ROUTER, AMCConstants.PRICING_URI)}>see plans</a></button></td>
						<td><button className="BannerFOMOSeePlansButton"><a href={AMCConstants.PRICING_URI} onClick={ROUTER.pushRoute.bind(ROUTER, AMCConstants.PRICING_URI)}>see plans</a></button></td>
					</tr>
				</tbody></table>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/AMCBanners.js